import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AwarenessCards } from './components/AwarenessCards';
import { AboutMe } from './components/AboutMe';
import { ConceptTPV } from './components/ConceptTPV';
import { WorkWithMe } from './components/WorkWithMe';
import { CommunityGift } from './components/CommunityGift';
import { Testimonials } from './components/Testimonials';
import { FooterCTA } from './components/FooterCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <div id="hero" data-id="element-2">
        <Hero data-id="element-3" />
      </div>
      <AwarenessCards data-id="element-4" />
      <div id="despre-mine" data-id="element-5">
        <AboutMe data-id="element-6" />
      </div>
      <ConceptTPV data-id="element-7" />
      <div id="terapie" data-id="element-8">
        <WorkWithMe data-id="element-9" />
      </div>
      <CommunityGift data-id="element-10" />
      <div id="marturii" data-id="element-11">
        <Testimonials data-id="element-12" />
      </div>
      <FooterCTA data-id="element-13" />
      <div id="contact" data-id="element-14">
        <Footer data-id="element-15" />
      </div>
    </div>;
}